// extracted by mini-css-extract-plugin
module.exports = {"allLink":"_167824b","allButton":"_64eaac1","icon":"_68a8578","right":"_79a7cf1"};